export const END_POINT = window.env.END_POINT;
export const END_STATIC_POINT = window.env.END_STATIC_POINT;
export const LOG_VIEWER = window.env.LOG_VIEWER;


// WEBPACK FOOTER //
// ./src/constants/config.js